import React, { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useMutation, useQuery } from 'react-query';
import { Scaffold } from 'layouts';
import { FormPageHeader } from 'components/Shared';
import { UpdateForm } from 'components/Pages/ChecklistTemplates';
import { useChecklistTemplates } from 'hooks/api/useChecklistTemplates';
import { useToast } from 'components/ui/use-toast';
import * as S from './styles';

export const ChecklistTemplateUpdatePage: React.FC = () => {
  const { id } = useParams() as { id: string };
  const navigate = useNavigate();
  const { toast } = useToast();
  const { getChecklistTemplate, updateChecklistTemplate } =
    useChecklistTemplates();

  const { data: template, isLoading } = useQuery({
    queryKey: ['checklistTemplate', id],
    queryFn: () => getChecklistTemplate(id),
    onError: () => {
      toast({
        variant: 'destructive',
        title: 'Erro',
        description: 'Checklist não encontrado',
        duration: 5000,
      });
      navigate('/configuracoes/checklist/modelos');
    },
  });

  const updateMutation = useMutation(
    (payload: { name: string; google_id: string; slug: string }) =>
      updateChecklistTemplate(id, payload),
    {
      onSuccess: () => {
        toast({
          title: 'Sucesso',
          description: 'Checklist atualizado com sucesso',
          duration: 5000,
        });
        navigate('/configuracoes/checklist/modelos');
      },
      onError: (error: any) => {
        toast({
          variant: 'destructive',
          title: 'Erro',
          description:
            error?.response?.data?.message || 'Erro ao atualizar checklist',
          duration: 5000,
        });
      },
    }
  );

  const onSubmit = useCallback(
    async (data: { name: string; google_id: string; slug: string }) => {
      await updateMutation.mutateAsync(data);
    },
    [updateMutation]
  );

  return (
    <Scaffold>
      <S.PageContainer>
        <S.MainPanel>
          <FormPageHeader
            title="Editar modelo de checklist"
            icon={<S.BookContentIcon />}
            isLoading={isLoading}
            actions={
              <S.LinkButton
                size="small"
                to="/configuracoes/checklist/modelos"
              >
                <S.ArrowLeftIcon /> Voltar
              </S.LinkButton>
            }
          />
          <UpdateForm
            template={template}
            loading={updateMutation.isLoading}
            onSubmit={onSubmit}
          />
        </S.MainPanel>
      </S.PageContainer>
    </Scaffold>
  );
};
